/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import React from "react";

import axios from "axios";
import ReactDOM from "react-dom/client";

import { MetronicI18nProvider } from "./_metronic/i18n";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
} from "./_metronic/layout";
import App from "./app/App";
import store, { persistor } from "./redux/store";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "react-datepicker/dist/react-datepicker.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "./index.scss"; // Standard version

axios.defaults.withCredentials = true;

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */

// _redux.mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// _redux.setupAxios(axios, store);

const container = document.getElementById("root");

const root = ReactDOM.createRoot(container);

root.render(
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <App store={store} persistor={persistor} />
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>,
);

if (module.hot) {
  // Whenever a new version of App.js is available
  module.hot.accept("./app/App", function() {
    // Require the new version and render it instead
    root.render(
      <MetronicI18nProvider>
        <MetronicLayoutProvider>
          <MetronicSubheaderProvider>
            <MetronicSplashScreenProvider>
              <App store={store} persistor={persistor} />
            </MetronicSplashScreenProvider>
          </MetronicSubheaderProvider>
        </MetronicLayoutProvider>
      </MetronicI18nProvider>,
    );
  });
}
